// extracted by mini-css-extract-plugin
module.exports = {"artWrap":"art_artWrap__0ZKea","artWrapCustomFont":"art_artWrapCustomFont___qMdJ","artPageWrap":"art_artPageWrap__207vD"};